import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { ResearchData } from '../shared/models/local-profile-research/research-data';

@Injectable({
  providedIn: 'root'
})
export class LocalProfileResearchService {
  private baseUrl = `${environment.urlConfig.serviceUrl}/localprofileresearch`;

  constructor(private http: HttpClient) { }

  getLatest(customerId: number): Observable<ResearchData> {
    const params = new HttpParams().set('customerId', customerId);
    return this.http.get<ResearchData>(`${this.baseUrl}/latest`, { params: params });
  }
}
